import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpenCheck, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function PrepCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/test-prep/summary").then((r) => setS(r.data)).catch(() => setS({})); }, []);
  const target = s?.targets?.[0];
  return (
    <Link to={target ? `/prep/exam/${target.id}` : "/prep"} data-testid="dash-test-prep-card"
      className="mt-6 flex items-center justify-between gap-4 rounded-2xl border border-indigo-400/30 bg-gradient-to-r from-[#141A3A] to-[#131C2E] p-5 transition-transform hover:scale-[1.005]">
      <div className="flex items-center gap-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-400/15"><BookOpenCheck className="h-6 w-6 text-indigo-300" /></div>
        <div>
          <p className="font-mono-data text-[11px] uppercase tracking-wider text-indigo-300">Test Preparation</p>
          <p className="font-semibold text-white">{target ? `${target.name} ${target.level !== "class12" ? target.session : ""}` : "Prepare smarter. Practice. Test. Improve."}</p>
          <p className="text-sm text-slate-400">
            {s?.tests_taken ? `${s.tests_taken} tests · ${s.questions_attempted} questions · ${s.avg_accuracy}% accuracy` : "Quick, topic, chapter, subject and full mock tests with AI analysis"}
          </p>
        </div>
      </div>
      <span className="inline-flex shrink-0 items-center gap-1 text-sm font-semibold text-indigo-300">{target ? "Continue" : "Start preparing"} <ArrowRight className="h-4 w-4" /></span>
    </Link>
  );
}
